import api from '../../services/api';
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

// Async thunk for getting all marks entries
export const getStudentsByFiltersForMarks = createAsyncThunk(
  'marks/getAllForMarks',
  async (filters) => {
    try {
      const response = await api({
        baseURL: process.env.REACT_APP_API_BASE_URL,
        url: '/marks/',
        method: 'GET',
        headers: filters ? { ...filters } : {},
      });
      return response?.data;
    } catch (error) {
      console.log('Error fetching marks entries:', error);
      throw error;
    }
  },
);
export const getStudentsByFiltersForReports = createAsyncThunk(
  'marks/getAllForReports',
  async (filters) => {
    try {
      const response = await api({
        baseURL: process.env.REACT_APP_API_BASE_URL,
        url: '/marks/report',
        method: 'GET',
        headers: filters ? { ...filters } : {},
      });
      return response?.data;
    } catch (error) {
      console.log('Error fetching marks entries:', error);
      throw error;
    }
  },
);

export const createMarksEntry = createAsyncThunk(
  'marks/create',
  async (payload) => {
    try {
      const response = await api({
        baseURL: process.env.REACT_APP_API_BASE_URL,
        url: '/marks/',
        method: 'POST',
        data: payload,
        headers: {
          examType: payload.examType,
          departmentName: payload.departmentName,
          classesName: payload.classesName,
          sectionName: payload.sectionName || null,
          instituteType: payload.instituteType,
        },
      });
      return response?.data;
    } catch (error) {
      console.log('Error creating marks entry:', error);
      throw error;
    }
  },
);

export const downloadStudentMarksReport = createAsyncThunk(
  'marks/downloadReport',
  async (filters) => {
    try {
      const response = await api({
        baseURL: process.env.REACT_APP_API_BASE_URL,
        url: '/marks/downloadStudentMarks',
        method: 'GET',
        headers: filters ? { ...filters } : {},
        responseType: 'blob',
      });
      return response?.data;
    } catch (error) {
      console.log('Error downloading student marks report:', error);
      throw error;
    }
  },
);

export const downloadAllStudentsMarksExcel = createAsyncThunk(
  'marks/downloadAllStudentsMarksExcel',
  async (filters, { rejectWithValue }) => {
    try {
      const response = await api({
        baseURL: process.env.REACT_APP_API_BASE_URL,
        url: '/marks/downloadAllData',
        method: 'GET',
        headers: filters ? { ...filters } : {},
        responseType: 'blob',
      });
      return response?.data;
    } catch (error) {
      console.log('Error downloading all data:', error);
      return rejectWithValue({
        data: error?.response?.data,
        status: error?.response?.status,
      });
    }
  },
);

export const downloadAllStudentsMarksPDF = createAsyncThunk(
  'marks/downloadAllStudentsMarksPDF',
  async (filters, { rejectWithValue }) => {
    try {
      const response = await api({
        baseURL: process.env.REACT_APP_API_BASE_URL,
        url: '/marks/downloadSectionPdf',
        method: 'GET',
        headers: filters ? { ...filters } : {},
        responseType: 'blob',
      });
      return response?.data;
    } catch (error) {
      console.log('Error downloading all students marks PDF:', error);
      return rejectWithValue({
        data: error?.response?.data,
        status: error?.response?.status,
      });
    }
  },
);

export const downloadAllStudentsRankWisePDF = createAsyncThunk(
  'marks/downloadAllStudentsRankWisePDF',
  async (filters, { rejectWithValue }) => {
    try {
      const response = await api({
        baseURL: process.env.REACT_APP_API_BASE_URL,
        url: '/marks/rank',
        method: 'GET',
        headers: filters ? { ...filters } : {},
        responseType: 'blob',
      });
      return response?.data;
    } catch (error) {
      console.log('Error downloading all students rank-wise PDF:', error);
      return rejectWithValue({
        data: error?.response?.data,
        status: error?.response?.status,
      });
    }
  },
);
const marksSlice = createSlice({
  name: 'marks',
  initialState: {
    marksEntries: [],
    students: [],
  },
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getStudentsByFiltersForMarks.fulfilled, (state, action) => {
      state.students = action.payload;
    });
    builder.addCase(createMarksEntry.fulfilled, (state, action) => {
      state.marksEntries.push(action.payload);
    });
    builder.addCase(
      getStudentsByFiltersForReports.fulfilled,
      (state, action) => {
        state.students = action.payload;
      },
    );
  },
});

export default marksSlice.reducer;
